import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-10 bg-secondary-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-3">
              Why Pandabuy Sheet?
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              The Smarter Way to Shop Online
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                Shopping online often means juggling dozens of tabs, comparing prices across multiple sites, and second-guessing whether you are getting real value. The <strong>Pandabuy Sheet</strong> changes all of that by consolidating everything into one clean, organized spreadsheet.
              </p>
              <p>
                Our curated spreadsheets pull together product data, price points, quality ratings, and value scores across <strong>14 shopping categories</strong> — from sneakers and hoodies to perfumes, bags, and accessories. Every listing is structured so you can compare items side by side without the noise of endless scrolling or biased reviews.
              </p>
              <p>
                Whether you are hunting for the best budget sneakers, trying to find a jacket that balances cost and quality, or simply exploring what is trending across multiple categories, the Pandabuy Sheet gives you the clarity to make faster, smarter buying decisions.
              </p>
              <p>
                No guesswork. No overpaying. Just clean, data-driven comparisons that put the power back in your hands. And with daily updates, you are always looking at fresh, relevant product information.
              </p>
            </div>
            <Link
              to="/guide/pandabuy-sheet-guide"
              className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-primary-600 hover:text-primary-800 transition-colors cursor-pointer"
            >
              Read the full guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              <div className="bg-background-50 rounded-lg p-5 md:p-6">
                <p className="font-heading text-3xl md:text-4xl font-bold text-accent-600">
                  500<span className="text-xl">+</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-snug">
                  Curated product listings updated daily
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 md:p-6">
                <p className="font-heading text-3xl md:text-4xl font-bold text-accent-600">
                  14<span className="text-xl">+</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-snug">
                  Shopping categories with detailed comparisons
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 md:p-6">
                <p className="font-heading text-3xl md:text-4xl font-bold text-accent-600">
                  100<span className="text-xl">%</span>
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-snug">
                  Free access to all comparison spreadsheets
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 md:p-6">
                <p className="font-heading text-3xl md:text-4xl font-bold text-accent-600">
                  Free
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-snug">
                  No sign-up required — start browsing instantly
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}